module.exports = __webpack_public_path__ + "static/media/mario.a98fe01b.png";